import cn from "classnames";

const Text = ({
  children,
  color = "dark",
  className = "",
  weight = "",
  size = "",
  style = {},
  removeGap = false,
}) => {
  const customStyle = removeGap ? { margin: 0, padding: 0 } : {};
  const classNames = cn("a-txt", className, {
    [`a-txt--${color}`]: color, // white || dark
    [`a-txt--w-${weight}`]: weight, // bold, medium, regular
    "a-txt--large": size === "large",
    "a-txt--medium": size === "medium",
    "a-txt--base": size === "normal",
    "a-txt--small": size === "small",
    "a-txt--micro": size === "micro",
  });

  return (
    <p className={classNames} style={{ ...style, ...customStyle }}>
      {children}
    </p>
  );
};

export default Text;
